/* NÓMADA · Carrito lateral: agregar recomendados, códigos de descuento y flechas */
(function () {
  if (window.__nmdCartLoaded) return;
  window.__nmdCartLoaded = true;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsParam(drawer) {
    return drawer.getSectionsToRender().map(function (s) { return s.id; });
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function currentCodes() {
    return Array.prototype.map.call(document.querySelectorAll('[data-nmd-code-pill]'), function (el) {
      return el.getAttribute('data-nmd-code-pill');
    });
  }

  function collectCodes(cart) {
    var out = [];
    function add(app) {
      if (app && app.type === 'discount_code') out.push(String(app.title).toLowerCase());
    }
    (cart.cart_level_discount_applications || []).forEach(add);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) { add(a.discount_application); });
    });
    return out;
  }

  /* Agregar un producto recomendado */
  function addVariant(btn) {
    var drawer = getDrawer();
    if (!drawer) return;
    var card = btn.closest('.nmd-rec');
    var select = card ? card.querySelector('[data-nmd-variant]') : null;
    var id = select ? select.value : btn.getAttribute('data-variant-id');
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    postJSON(window.routes.cart_add_url + '.js', {
      items: [{ id: Number(id), quantity: 1 }],
      sections: sectionsParam(drawer),
      sections_url: window.location.pathname
    }).then(function (res) {
      if (res.status) {
        btn.textContent = 'No disponible';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
        return;
      }
      drawer.renderContents(res);
    }).catch(function () {
      btn.textContent = original;
      btn.disabled = false;
    });
  }

  /* Aplicar o quitar códigos de descuento (Cart API: /cart/update.js con "discount") */
  function updateCodes(list, attempted) {
    var drawer = getDrawer();
    if (!drawer) return;
    var form = document.querySelector('[data-nmd-code-form]');
    var submit = form ? form.querySelector('button[type=submit]') : null;
    if (submit) submit.disabled = true;
    postJSON(window.routes.cart_update_url + '.js', {
      discount: list.join(','),
      sections: sectionsParam(drawer),
      sections_url: window.location.pathname
    }).then(function (res) {
      if (res.status) throw new Error(res.description || 'error');
      var failed = attempted && collectCodes(res).indexOf(attempted.toLowerCase()) === -1;
      drawer.renderContents(res);
      if (failed) {
        var f = document.querySelector('[data-nmd-code-form]');
        if (!f) return;
        var input = f.querySelector('input[name=code]');
        var msg = document.querySelector('[data-nmd-code-msg]');
        if (input) input.value = attempted;
        if (msg) {
          msg.textContent = 'No pudimos aplicar este código. Revisa que esté bien escrito y que aplique a tu carrito.';
          msg.hidden = false;
        }
      }
    }).catch(function () {
      if (submit) submit.disabled = false;
      var msg = document.querySelector('[data-nmd-code-msg]');
      if (msg) {
        msg.textContent = 'Algo salió mal. Intenta de nuevo.';
        msg.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var add = t.closest('[data-nmd-add]');
    if (add) {
      e.preventDefault();
      addVariant(add);
      return;
    }

    var arrow = t.closest('[data-nmd-arrow]');
    if (arrow) {
      var recs = arrow.closest('.nmd-recs');
      var track = recs ? recs.querySelector('.nmd-recs__track') : null;
      if (track) {
        var dir = arrow.getAttribute('data-nmd-arrow') === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      }
      return;
    }

    var rm = t.closest('[data-nmd-remove-code]');
    if (rm) {
      var code = rm.getAttribute('data-nmd-remove-code');
      var remaining = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      updateCodes(remaining, null);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-nmd-code-form]')) return;
    e.preventDefault();
    var input = form.querySelector('input[name=code]');
    var code = ((input && input.value) || '').trim();
    if (!code) return;
    var msg = document.querySelector('[data-nmd-code-msg]');
    if (msg) msg.hidden = true;
    var list = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    list.push(code);
    updateCodes(list, code);
  });
})();